import Modal from "react-modal";

const Loader = ({
  isOpen = false,
  title = "Please Wait",
  heading = "Loading...",
  message = "Please wait while we process your request.",
  warning = "Please do not close, refresh, or leave this page.",
}) => {
  return (
    <Modal
      className="modalWallet"
      isOpen={isOpen}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      onRequestClose={() => {}}
      ariaHideApp={false}
      contentLabel="Transaction Processing"
      style={{
        overlay: {
          zIndex: 20000,
          backgroundColor: "rgba(0, 0, 0, 0.72)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },

        content: {
          position: "relative",
          inset: "auto",
          border: "none",
          background: "transparent",
          padding: "0",
          overflow: "visible",
        },
      }}
    >
      <div className="popupcenter text-center transactionLoaderPopup">

        <div className="edittext mb-2 modalHeader">

          <h5 className="colorDown upper">
            {title}
          </h5>

          <span className="loaderM"></span>

          <h6 className="mb-1 Bold">
            {heading}
          </h6>

          <div
            className="chain-dropdown-button swapBox justify-content-center f14"
            style={{
              padding: "5px",
              marginTop: "12px",
              color: "#a7a7a7",
            }}
          >
            {message}
          </div>

          {/* {warning && (
            <div className="transactionWarning mt-3">
              <i className="fa-solid fa-circle-info me-1"></i>

              {warning}
            </div>
          )} */}

        </div>

      </div>
    </Modal>
  );
};

export default Loader;